import YupEn from "components/bng/form/yup/YupEn";
import YupPt from "components/bng/form/yup/YupPt";
import YupEs from "components/bng/form/yup/YupEs";

export const YupLang = {
    'en': YupEn,
    'pt': YupPt,
    'es': YupEs,
};